const config = {
    authority: 'https://candidateaccountauth-apps-eun-test.azurewebsites.net',
    client_id: 'http://localhost/eRS.Service.CandidateAccount',

    redirect_uri: 'http://localhost/eRS.Service.CandidateAccount/SigninRedirect',

    response_type: 'token',
    scope: 'candidateAccountReadAccess candidateAccountWriteAccess'
};
export default config;
